var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"controlplan"},[_c('h1',[_vm._v(_vm._s(_vm.$t('an_cphygienecode', { ns: 'analytics' })))]),_c('HygienecodeJaarschema')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }